// extracted by mini-css-extract-plugin
export default {"direccion":"Academias_direccion__pKAkj","region":"Academias_region__n97vQ","activo":"Academias_activo__uJn28"};